/** @format */

import { useEffect } from "react";
import { useTranslation } from "react-i18next";

function useDocumentTitle(
  title: string /* this is the translation string not the string displayed*/,
) {
  const { t: _, i18n } = useTranslation();

  useEffect(() => {
    document.title = _(title);
  }, [_, title, i18n.language]);
}

export default useDocumentTitle;
